import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'antd';
import moment from 'moment';


// @styles
import './styles.scss'

// @images 
import loading from 'assets/images/load.svg'
import alertLoad from 'assets/images/alert-load.png'
import Context from 'context/appContext';
import { getBody, getBodyRedirect, validateIsBefore } from 'utils/utils';
import AlertMessage from 'components/alert-message';

export default function ModalLoad({ persistenceM, setPersistenceModel, isRedirect, setIsRedirect, form, isPaymentRedirect }) {
    const [isError, setIsError] = useState(false);
    const [url, setUrl] = useState("");

    const { dataForm: { data, formResponses }, customRequest,
        insureds, tokenInfo, setShowHomePage, setProgressStep, progressStep } = useContext(Context);

    useEffect(() => { redirect() }, []);

    useEffect(() => {
        if (url) {
            window.location.href = url
        }
    }, [url]);

    const validateUrl = () => {
        // const result = validateIsBefore(persistenceM);
        // if (result && result.isBefore) {
        //     !isPaymentRedirect && setUrl(result.url);
        //     setIsRedirect(result.isBefore);
        // }
        //  redirect();
    }

    const redirect = async () => {
        const options = JSON.parse(process.env.REACT_APP_OPTIONS_GET_URL_PAYMENT);
        const body = getBody({}, data.modelConfig, formResponses, insureds, tokenInfo, form);
        const policy = data.infoRequote && data.infoRequote.res && data.infoRequote.res.data.policy;
        const costs = data.infoRequote && data.infoRequote.res && data.infoRequote.res.data && data.infoRequote.res.data.costs;
        const newBody = getBodyRedirect(body, policy, policy && data.infoRequote.res.data, formResponses);
        const response = await customRequest(options.url, options.header, options.method, newBody);
        if (response && response.data && response.data.success && response.data.urlRedirect) {
            const urlPayment = { ...response.data, create_date: moment().format('YYYY-MM-DD hh:mm:ss') }
            setUrl(response.data.urlRedirect);
            setPersistenceModel(persistenceModel => ({
                ...persistenceModel,
                componentes: formResponses,
                payment: [...persistenceModel.payment || [], { payment: { status: 'redirect', quoteDate: moment().format('YYYY-MM-DD hh:mm:ss'), quotePrice: costs && costs.amount, numberReference: '' } }],
                urlPayment: [...persistenceModel.urlPayment || [], urlPayment]
            }));
            setIsRedirect(true)
            setProgressStep([...progressStep]);
        } else {
            setIsError(true);
        }
    }

    return (
        <Modal
            width='760px'
            visible={true}
            destroyOnClose
            footer={null}
            title={null}
            centered
            closable={false}
            wrapClassName='modal-warning'
        >
            {isError ? (<AlertMessage info={{ type: 'error' }} />) :
                <div
                    className='alert-loading'
                    style={{
                        backgroundImage: `url('${alertLoad}')`
                    }}
                >
                    <div className='alert-loading-text'>
                        <h2 className='alert-loading-text__title'>
                            ¡Gracias por confiarnos tu protección!
                        </h2>
                        <p className='alert-loading-text__parag'>
                            Pronto estarás en la pasarela de pagos.
                        </p>
                    </div>
                    <div className='alert-loading-img'>
                        <img src={loading} alt='Loading'/>
                    </div>
                </div>}
        </Modal>
    )
}